import { SubmitButton } from "@/components/Global/Button/Button";
import { FormErrorState, Input } from "@/components/Global/Input/Input";
import { useAppContext } from "@/context/AppContext";
import { passwordReset } from "@/utils/serviceAPI/password";
import { safeParseSchema, emailSchema } from "@/utils/validations";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React, { FormEvent, useState } from "react";

export const PasswordResetForm = () => {
  const { getLabel } = useGlobalContext();
  const { setFormModalType, setFormModalText } = useAppContext();
  /* jscpd:ignore-start */
  const validationMessages = {
    email_invalid: getLabel("email_invalid"),
    required_field: getLabel("required_field"),
  };
  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const formProps = Object.fromEntries(formData);
    const { data, flattenedErrors } = safeParseSchema(
      emailSchema(validationMessages),
      formProps,
    );
    if (data) {
      setErrors({});
      const res = await passwordReset((data as { email: string }).email);
      if (res) {
        setFormModalType("text");
        setFormModalText(getLabel("login_form_notification_password_reset"));
      }
    } else {
      setErrors(flattenedErrors);
    }
  }
  /* jscpd:ignore-end */
  const [errors, setErrors] = useState<FormErrorState>();
  return (
    <form onSubmit={handleSubmit}>
      <Input
        inputType="email"
        name="email"
        label={getLabel("login_form_label_email")}
        placeholder={getLabel("login_form_placeholder_email")}
        errors={errors}
      ></Input>
      <SubmitButton>
        {getLabel("login_form_label_button_password_reset")}
      </SubmitButton>
    </form>
  );
};
